import React from 'react';
import { styled } from '@glitz/react';
import { TextBlockSmall, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import * as style from 'Shared/Style';
import FillableCircles from 'Shared/SharedComponents/molecules/FillableCircles';

type ReviewsLabels = {
  reviews: string;
  description?: string;
}

type ReviewsType = {
  rating: number;
  numberOfReviews: number;
  flexColumn?: boolean;
  onClick?: () => void;
  labels: ReviewsLabels;
};

const Wrap = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '24px'
})

const Inner = styled.div({
  position: 'relative',
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
})

const InnerFlexColumn = styled(Inner, {
  flexDirection: 'column',
  alignItems: undefined,
})

function Reviews({ labels, rating, numberOfReviews, flexColumn = false, onClick = null }: ReviewsType) {
  const InnerElement = flexColumn ? InnerFlexColumn : Inner;

  return (
    <Wrap css={{ ...(onClick && { cursor: 'pointer' }) }}>
      {!!labels?.description && <TextBlockSmall upperCase>{labels.description}</TextBlockSmall>}
      <InnerElement onClick={onClick}>
        <FillableCircles numberToFill={rating}></FillableCircles>
        <TextBlockSmall
          fontSize={ResponsiveSize.D12_M12}
          upperCase
          css={{ color: style.colors.monochrome.a11ygrey }}
        >{`${numberOfReviews} ${labels?.reviews}`}</TextBlockSmall>
      </InnerElement>
    </Wrap>
  );
}

export default Reviews;
